import { useTranslation } from "react-i18next";
import "../player/Player.css";

function SimulatorLoading() {
  const { t } = useTranslation();

  return (
    <div
      style={{
        position: "relative",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        width: "100vw",
        backgroundColor: "#000",
      }}
    >
      <img
        src="/images/sparkles.gif"
        alt={t("SparklesAlt")}
        className="Sparkles"
        width="220px"
      />
    </div>
  );
}

export default SimulatorLoading;
